const reducer = (state, action) => {
    switch (action.type) {
        case 'resolve':
            return { ...state, IsChangedOverride: true };
        case 'patch':
            return { ...state, ...action.changes };
        case 'dismiss':
            return { AppInstID: state.AppInstID };
        default:
            return state;
    }
};

export default reducer;
